import { useEffect } from "react";

function PostMessage({ children }) {
  useEffect(() => {
    if (window.parent === window) return;
    const root = document.getElementById("root");
    if (!root) return;

    let lastHeight;
    let frame = null;
    const notifyHeight = () => {
      frame = null;
      const height = root.offsetHeight;
      if (height !== lastHeight) {
        lastHeight = height;
        window.parent.postMessage({ frameHeight: height }, "*");
      }
    };
    const scheduleHeight = () => {
      if (frame === null) {
        frame = window.requestAnimationFrame(notifyHeight);
      }
    };
    const observer =
      typeof ResizeObserver === "function"
        ? new ResizeObserver(scheduleHeight)
        : null;
    observer?.observe(root);
    window.addEventListener("resize", scheduleHeight);
    scheduleHeight();

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", scheduleHeight);
      if (frame !== null) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, []);

  return <div>{children}</div>;
}

export default PostMessage;
